import { useSafeLocalStorage } from './useSafeLocalStorage.js'

export const useEmail = () =>
  useSafeLocalStorage<string>(
    'email',
    '',
    (v) => typeof v === 'string',
  )
